<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon v-if="!this.$store.state.empresasStore.mantenimiento&editable" icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
      <!-- <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" /> -->
    </div>
</template>

<script>
import operacionesStore from '@/store/gestion/operaciones/index.js'

export default {
  name: 'CellRendererActions',
  computed: {
    editable () {
      /**
       * Só mostramos o icono para editar operacións se a operación está 'INCOMPLETA' ou, en caso contario, se o usuario pertence a 'ROLE_ADMIN'
       */
      let editable = false
      if (this.params.data.estado === 'INCOMPLETA' || this.$store.state.AppActiveUser.userRole === 'ROLE_ADMIN') editable = true
      return editable
    }
  },
  methods: {
    async editRecord () {
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      try {
        if (!operacionesStore.isRegistered) {
          this.$store.registerModule('operacionesStore', operacionesStore)
          operacionesStore.isRegistered = true
        }

        await this.$store.dispatch('operacionesStore/getOperacion', this.params.data.id)
          .then((response) => {
            this.operacion = response.data
            // this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
          })
          .catch(
            // this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
          )
      } catch (error) {
        console.error(error)
      }
      const ruta = `/gestion/operaciones/editar/${this.params.data.id}`
      this.$router.push(ruta).catch(() => {})
    }
  }
}
</script>
